import { ArrowUp, ArrowDown, Minus } from "lucide-react";

/**
 * MoM Delta pill — arrow + % change vs previous window.
 *
 * `direction` tells us whether "up" is good (higher_better) or bad
 * (lower_better) so we can color-code correctly. E.g. `incidents` going
 * up = red; `resolution_rate` going up = green.
 *
 * Props:
 *   delta       number | null   — % change vs prev period
 *   direction   "higher_better" | "lower_better"
 */
export default function TrendDelta({ delta, direction = "higher_better", testId }) {
  if (delta == null) {
    return (
      <span
        className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest text-zinc-600"
        data-testid={testId}
      >
        <Minus className="size-2.5" /> N/A
      </span>
    );
  }
  const positive = delta > 0.05;
  const negative = delta < -0.05;
  const flat = !positive && !negative;

  const isGood =
    flat
      ? null
      : (direction === "higher_better" ? positive : negative);
  const color = flat ? "#71717A" : (isGood ? "#22C55E" : "#EF4444");
  const Icon = flat ? Minus : (positive ? ArrowUp : ArrowDown);
  const sign = delta > 0 ? "+" : "";
  return (
    <span
      className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest font-bold"
      style={{ color }}
      data-testid={testId}
      title={`${sign}${delta}% vs previous window`}
    >
      <Icon className="size-2.5" strokeWidth={3} /> {sign}{Math.abs(delta)}%
    </span>
  );
}
